// MUI Imports
import type { BadgeProps } from '@mui/material/Badge';
import Badge from '@mui/material/Badge';

export type DsBadgeProps = BadgeProps & {
  size?: 'small' | 'medium' | 'large' | 'xLarge' | 'xxLarge';
  hasBorder?: boolean;
  tonal?: boolean;
};

export const DsBadge = (props: DsBadgeProps) => <Badge {...props} />;
